import React, { useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import SEO from '../components/SEO';

const ThankYou = () => {
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get('customerid');

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-slate-50 flex items-center justify-center px-4">
      <SEO title="Thank You" description="Your application has been submitted successfully." path="/application/main" />
      <div className="max-w-lg w-full text-center py-16">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-6">
          <CheckCircle className="h-10 w-10 text-green-600" />
        </div>
        <h1 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-4">Thank You!</h1>
        <p className="text-lg text-slate-600 mb-2">Your application has been submitted successfully.</p>
        {customerId && (
          <p className="text-slate-500 mb-6">Your reference ID: <span className="font-bold text-slate-800">#{customerId}</span></p>
        )}
        <p className="text-slate-600 mb-8">Our team will review your request and contact you within 24 hours.</p>
        <Link
          to="/"
          className="inline-flex items-center px-8 py-3 bg-secondary text-white font-semibold rounded-xl hover:bg-secondary-light transition-all duration-300"
          data-testid="back-home-btn"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default ThankYou;
